import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopMarketplaceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/Marketplace/MarketplaceBrowser")
	}

	render() {
		return (
			<Activity 
				name="Marketplace"
				RenderedComponent={this.RenderedComponent}
				context="Marketplace"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopMarketplaceActivity)
